import { brandFor } from '@/shared/content/brand';
import { PARTNER_SLUG } from '@/shared/lib/partner';
import styles from './pet-loader.module.scss';

const BRAND = brandFor(PARTNER_SLUG);

/**
 * Ожидание прямо в зоне печати, пока вырезается фон.
 *
 * Стоит на самой футболке, а не поверх экрана. Так человек видит, что
 * работа идёт именно с принтом, а остальное — цвет, размеры, кнопки —
 * остаётся доступным: ждать, уставившись в заблокированный экран,
 * неприятно, а выбрать размер можно и сейчас.
 *
 * Раньше на это время показывался исходный снимок, приглушённый. Это
 * читалось двусмысленно: непонятно, то ли идёт работа, то ли так
 * и задумано, — и человек нажимал «поменять фото», решив, что сломалось.
 *
 * Размеров своих нет: знак и кольцо заданы долями зоны печати, и на
 * телефоне, где зона втрое меньше, пропорции те же.
 */
export function LsPetLoader() {
  return (
    <span className={styles['ls-pet-loader']} role="status" aria-label="Убираем фон со снимка">
      {/*
        Кольцо и знак — один предмет: кольцо вращается вокруг знака,
        а знак стоит. Раньше кольцо лежало отдельным слоем поверх всего
        и наезжало на подпись.
      */}
      <span className={styles['ls-pet-loader__badge']} aria-hidden="true">
        <span className={styles['ls-pet-loader__ring']} />

        {BRAND.logoMiniUrl && (
          <img className={styles['ls-pet-loader__logo']} src={BRAND.logoMiniUrl} alt="" draggable={false} />
        )}
      </span>

      <span className={styles['ls-pet-loader__text']}>Убираем фон</span>
    </span>
  );
}
